<template>

  <v-layout ml-5="ml-5" row="row" align-center="align-center">
    <v-flex md5="md5">
      <v-text-field v-model="input" :placeholder="placeholder" :disabled="advanced" :clearable="true"></v-text-field>
    </v-flex>
    <v-flex md1="md1" ml-2="ml-2" v-if="expandable">
      <v-icon @click="$emit('update:advanced', !advanced)" title="Advanced search" medium="medium">{{ advanced ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </v-flex>
  </v-layout>

</template>

<script>

export default {
  name: 'ItemQuickSearch',
  props: {
    search: {
      type: String
    },
    advanced: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search by ID'
    },
    expandable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    input: {
      get () {
        return this.search
      },
      set (v) {
        this.$emit('update:search', v || '')
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/ItemQuickSearch.vue